import React, { forwardRef, useState } from 'react';
import { Controller } from 'react-hook-form';
import { useFormContext } from './FormProvider';
import PropTypes from 'prop-types';
import PasswordInput from '../PasswordInput/PasswordInput';

const PasswordInputComponent = forwardRef(({ ...props }, ref) => (
  <PasswordInput ref={ref} {...props} />
));

PasswordInputComponent.displayName = "PasswordInputComponent";

export const FormPassword = ({ 
  name,
  label, 
  validateRemote = false,
  validateDelay = 500,
  ...props 
}) => {
  const { 
    control, 
    formConfig
  } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <PasswordInputComponent
          {...field}
          {...formConfig}
          {...props}
          label={label}
          error={!!error}
          helperText={error?.message ? error?.message : props.helperText}
        />
      )}
    />
  );
};

FormPassword.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  validateRemote: PropTypes.bool,
  validateDelay: PropTypes.number,
};